import Button from '../../../../components/ui/Button';
import './Header.scss';

const Header = ({ image, title, showContent = true }) => {
    const headerStyle = {
        backgroundImage: `url(${image})`,
    };

    const headerClass = showContent
        ? 'Header__subscribe'
        : 'Header__no-content';

    return (
        <section class={headerClass} style={headerStyle}>
            {showContent && (
                <div class="container">
                    <h1 class="heading heading--large heading--white">
                        {title}
                    </h1>
                    <ul class="list list--checks list--checks text--white">
                        <li>Elke speelronde alle Eredivisiewedstrijden live</li>
                        <li>
                            Live wedstrijden uit de Keuken Kampioen Divisie,
                            TOTO KNVB Beker en Vrouwen Eredivisie
                        </li>
                        <li>
                            Live internationaal voetbal uit de UEFA Europa
                            League en UEFA Conference League
                        </li>
                        <li>
                            Spraakmakende voetbalprogramma's, zoals De
                            Eretribune, Voetbalpraat, ESPN Vandaag,
                            <br />
                            documentaires en Club TV
                        </li>
                        <li>Meer dan voetbal: NBA, MLB, NFL en NHL</li>
                        <li>Op 4 kanalen, inclusief ESPN Watch</li>
                    </ul>
                    <Button
                        label="Selecteer jouw tv-aanbieder"
                        link="#providers"
                        type="primary"
                        size="large"
                        track="campagne:abonneren:selecteer-tv-aanbieder"
                    />
                </div>
            )}
        </section>
    );
};

export default Header;
